import { jsx as _jsx } from "react/jsx-runtime";
import { InputWrapper } from "./InputWrapper";
export const InputField = (props) => {
    const { formLabel, errorMessage, ...rest } = props;
    return (_jsx(InputWrapper, { formName: rest.name, formLabel: formLabel, errorMessage: errorMessage, children: _jsx("input", { ...rest, type: "text" }) }));
};
